import { Head } from "@inertiajs/react"
import { PublicShell } from "@/components/PublicShell"
import { ClosingCta } from "@/components/landing/ClosingCta"
import { Hero } from "@/components/landing/Hero"
import { Offers } from "@/components/landing/Offers"
import { SiteFooter } from "@/components/landing/SiteFooter"
import { SiteHeader } from "@/components/landing/SiteHeader"
import { CaseStudies } from "@/components/landing/CaseStudies"
import { Results } from "@/components/landing/Results"
import { Testimonials } from "@/components/landing/Testimonials"
import { assertNoAdjacentTones } from "@/components/landing/section-tone"

const TITLE = "Matthew Traynor | Freelance Google Ads Consultant"
const DESCRIPTION =
  "Independent Google and Microsoft Ads specialist. $5M+ managed across 60+ businesses. I find where your budget is leaking, fix it, and turn spend into leads that convert."

// The public landing page. Light-only: the `landing-scope` wrapper re-declares
// the light palette so the page stays light regardless of OS/dark preference.
// The lead form lives in the hero; the closing CTA scrolls back up to it.
export default function Home() {
  // above the always-light landing page. When present it is stacked above the

  // Section background rhythm — the single source of truth (see section-tone.ts).
  // No two connected sections share a tone; the navy "How we can work" island and
  // the navy closing CTA break up the page/surface run. `assertNoAdjacentTones`
  // throws in dev if this order ever puts two matching backgrounds side by side.
  const tones = {
    hero: "page",
    testimonials: "surface",
    offers: "tint",
    caseStudies: "surface",
    results: "page",
    cta: "navy",
  } as const
  assertNoAdjacentTones([
    tones.hero,
    tones.testimonials,
    tones.offers,
    tones.caseStudies,
    tones.results,
    tones.cta,
  ])

  return (
    <>
      <Head title={TITLE}>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:type" content="website" />
      </Head>

      <PublicShell>
        <div className="landing-scope min-h-dvh bg-page">
          <SiteHeader />
          <main>
            <Hero />
            <Testimonials tone={tones.testimonials} />
            <Offers tone={tones.offers} />
            <CaseStudies tone={tones.caseStudies} />
            <Results tone={tones.results} />
            <ClosingCta />
          </main>
          <SiteFooter />
        </div>
      </PublicShell>
    </>
  )
}
